
      import styled from "styled-components";

      const ProfileStyled = styled.div``;

      export { ProfileStyled };
      